import { RoomSession } from '../models/Room'
import { RoomSession as SDKRoomSession } from '@zocks-communications/client-sdk-js'

const MAX_SUPPORTED_MEETING_LENGTH_MS = 10 * 60 * 60 * 1000
const FIVE_MINUTES_MS = 5 * 60 * 1000

export function isLiveSession(roomSession?: RoomSession | SDKRoomSession | null): boolean {
  if (roomSession == null) {
    return false
  }

  if (roomSession.isActive) {
    return true
  }

  const now = Date.now()
  const startedAt = new Date(roomSession.startedAt).getTime()
  const finishedAt = roomSession.finishedAt ? new Date(roomSession.finishedAt).getTime() : null

  if (Number.isNaN(startedAt) || Number.isNaN(finishedAt)) {
    return false
  }

  const aboutToStart = startedAt <= now + FIVE_MINUTES_MS

  if (aboutToStart && finishedAt == null) {
    return true
  }

  const hasStartFinished = startedAt != null && finishedAt != null

  if (hasStartFinished && aboutToStart && finishedAt > now) {
    const duration = finishedAt - startedAt
    return duration <= MAX_SUPPORTED_MEETING_LENGTH_MS
  }

  return false
}
